<template>
	<CreationWizardStepWrapper>
		<template #header>
			<CreatePortalHeader v-bind="$props" v-on="$listeners" />
		</template>
		<Col class="height-100">
			<PortalNameInputField v-model="name" />

			<PortalAuthSettingsContent :settings.sync="customerAuthSettings" />
			<!-- <div class="flex-col-12">
				<div class="middle-section">
					<div>
						<h2 class="med">Create first and add placements later</h2>
						<h3 class="reg">Portal have their own URL, you can add them in multiple placements later.</h3>
					</div>
					<div>
						<div class="" v-for="ppd in portalPlacementDescriptions" :key="ppd">
							{{ ppd }}
						</div>
						<span> Or <span class="text-underline" role="button">Create a portal with contextual data</span> </span>
					</div>
				</div>
			</div> -->
			<div class="flex-1 flex-center--end pt-6">
				<PrimaryButton @click="create" :disabled="creationIsDisabled" :loading="loading">Create</PrimaryButton>
			</div>
		</Col>
	</CreationWizardStepWrapper>
</template>

<script>
import { FlowType, WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';

import { PORTAL_PLACEMENT_DESCRIPTIONS } from './CreatePortal.const';
import props from './CreatePortal.props';
import CreatePortalHeader from './CreatePortalHeader.vue';
import PortalNameInputField from './inputs/PortalNameInputField.vue';
import WizardStepMixin from '../WizardStepMixin';
import PortalAuthSettingsContent from '@/components/dialogs/PortalAuthSettingsDialog/PortalAuthSettingsContent.vue';
import { createAndSelectWorkflow, partialUpdateWorkflowVersionSettings } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { TOOL_PREFERENCES_URL_FLAG, URL_PLACEMENT_ID } from '@/utils/workflow-tool-service.const';

export default {
	name: 'CreatePortal',
	mixins: [WizardStepMixin],
	props,
	components: { CreatePortalHeader, PortalNameInputField, PortalAuthSettingsContent },
	computed: {
		portalPlacementDescriptions() {
			return PORTAL_PLACEMENT_DESCRIPTIONS;
		},
		creationIsDisabled() {
			return isNullOrUndefinedOrEmpty(this.name);
		},
	},
	methods: {
		...mapActionsShorthand({ createAndSelectWorkflow, partialUpdateWorkflowVersionSettings }),
		async create() {
			const toolPreferences = { main_placement: URL_PLACEMENT_ID, [TOOL_PREFERENCES_URL_FLAG]: true }; // for now auto-select url as main_placement of portal tool
			const workflow = {
				workflow_title: this.name,
				flow_type: FlowType.Tool,
				access_type: WorkflowAccessType.Anyone,
				project: this.selectedProjectId,
				tool_preferences: toolPreferences,
			};
			this.loading = true;
			try {
				// This will auto redirect to the new created flow!
				this.closeWizard();
				const newWorkflow = await this.createAndSelectWorkflow({ workflow, selectFirstNonRoot: true });
				this.partialUpdateWorkflowVersionSettings(this.customerAuthSettings);
				this.workflowCreated(newWorkflow);
			} catch (err) {
				this.$toast.error('Error occurred while creating new flow');
				console.error(err);
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return {
			name: '',
			loading: false,
			customerAuthSettings: { customer_auth_enabled: false, customer_auth_method: null, customer_auth_text: '' },
		};
	},
};
</script>

<style scoped lang="scss">
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.middle-section {
	h3 {
		color: $secondary-content-title-font-color;
	}
}
</style>
